module.exports = __webpack_public_path__ + "img/control-project.3e4ca6d8.png";